// Old WordPress page slugs still linked from blog posts and other sites.
//
// Each target is the redirect the WordPress site itself served (read from the
// WordPress staging copy, staging-thriverestorehair.kinsta.cloud, on 30 Sep
// 2026), so search engines see the same destination they learned before the
// migration. The three slugs WordPress no longer had are marked "no WP target"
// and point to the closest live page.

const LEGACY_PAGES: Record<string, string> = {
  "hair-transplant-surgeon-physician-bio": "/doctors/dr-james-harris/",
  "physician-cv-james-harris": "/doctors/dr-james-harris/",
  "hair-replacement-client-bill-of-rights": "/doctors/dr-james-harris/",
  "hair-transplant-reviews": "/reviews/",
  contact: "/contact-us/",
  "non-surgical-hair-restoration": "/non-surgical/",
  "minoxidil-rogaine": "/non-surgical/",
  fue: "/fue-hair-transplant-care-when-to-wash-your-hair/",
  "no-shave-fue": "/no-shave-fue-hair-transplant/",
  "female-pattern-baldness": "/hair-loss-in-women-exploring-female-pattern-baldness/",
  "female-pattern-baldness-2": "/thairapy/",
  "hairline-transplant-for-women": "/thairapy/",
  "causes-of-hair-loss-in-women": "/thairapy/",
  artas: "/artas-work-curly-hair/",
  "hair-loss-treatment": "/procedure/",
  fuht: "/procedure/",
  "follicular-unit-extraction": "/procedure/",
  "medical-hair-restoration": "/procedure/",
  "hairline-transplant": "/procedure/",
  "hair-loss-in-men": "/causes-of-hair-loss/",
  "causes-of-hair-loss-in-men": "/causes-of-hair-loss/",
  "s-a-f-e-system": "/history-of-fue/",
  "hsc-difference": "/locations/restore-denver/",
  "strip-method": "/locations/restore-denver/",
  "hair-transplant-before-and-after": "/results/",
  "erin-parisi": "/results/",
  "what-to-expect": "/what-to-expect-at-your-hair-restoration-consultation/",
  consultation: "/downloads/restore_presentation_mobile_v26-1.pdf",
  "privacy-terms": "/privacy-policy/",
  "hair-transplant-cost": "/the-true-hair-restoration-cost/",
  "hair-transplant": "/hair-transplant-an-effective-way-of-hair-restoration/",
  "hair-loss-hat-collection": "/hat-collection/",
  "correcting-previous-hair-surgeries": "/correcting-previous-hair-transplant-surgeries/",
  "genetics-and-hair-loss": "/genetics-and-hair-loss-who-do-you-inherit-it-from/",
  // no WP target
  "how-many-grafts-do-i-need-calculator": "/how-many-grafts/",
  "stars-with-hair-plugs": "/famous-people-with-hair-transplants/",
  "does-restore-use-robotics-in-hair-transplant-surgeries": "/faq/what-is-the-artas-robot/",
  // 404 pages that still had Google impressions from 1 to 28 Sep 2026
  // (Search Console). WordPress had no redirect for them either.
  "genes-and-hair-loss-who-do-you-inherit-it-from": "/genetics-and-hair-loss-who-do-you-inherit-it-from/",
  "no-shave-hair-transplant": "/no-shave-fue-hair-transplant/",
  "does-a-hair-transplant-hurt-is-an-fue-hair-transplant-painful": "/does-a-hair-transplant-hurt/",
  "the-norwood-scale": "/what-is-the-norwood-scale/",
  "hair-loss-braids": "/braiding-can-make-your-hair-fall-out/",
  // Old URLs that other sites still link to (Ahrefs referring domains, all
  // time, read on 1 Oct 2026). Targets follow the WordPress staging redirect
  // where it had one.
  deionsanders: "/results/deion-sanders/", // 42 + 16 referring domains
  prp: "/prp-treatment-for-hair-restoration-its-effectiveness-and-all-things-to-know-about-prp-therapy/", // 29, WP target
  "pricing-test": "/pricing/", // 20
  dallas: "/locations/texas/dallas-highland-park/", // 10, WP target
  mancow: "/", // 8, WP target
  "9-ways-encourage-hair-growth": "/10-ways-actually-make-hair-grow/", // 16, WP target
  "reverse-hair-loss": "/10-ways-actually-make-hair-grow/", // 7, WP target
  wise_choice: "/hair-restoration-research-tips/", // 1, WP target
  "the-cost-of-a-hair-transplant-pricing-information": "/the-true-hair-restoration-cost/", // 11
};

/**
 * The 301 target for a retired page slug, or null.
 *
 * Also handles Lovable's "clone-of-" duplicates (clone-of-clone-of-x): the
 * prefixes are stripped and the remaining slug is looked up again, falling
 * back to /<slug>/ when it is a live page.
 */
export function legacyPageRedirect(slug: string): string | null {
  // Old links use mixed case, for example /DeionSanders/.
  const direct = LEGACY_PAGES[slug] ?? LEGACY_PAGES[slug.toLowerCase()];
  if (direct) return direct;
  if (!slug.startsWith("clone-of-")) return null;
  const base = slug.replace(/^(clone-of-)+/, "");
  if (!base) return null;
  return LEGACY_PAGES[base] ?? `/${base}/`;
}
